var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from '@emotion/styled';
import { theme, M } from './Utils';
export var Div = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-family: ", ";\n  margin-top: 100px;\n  height: 100%;\n  @media (max-width: ", "px) {\n    margin-top: 75px;\n  }\n"], ["\n  font-family: ", ";\n  margin-top: 100px;\n  height: 100%;\n  @media (max-width: ", "px) {\n    margin-top: 75px;\n  }\n"])), theme.typography.normal.raleway, M);
var templateObject_1;
